
import React from "react";
import { withStyles, Box, Typography, InputBase, Divider, Button } from "@material-ui/core";
import _ from 'lodash';
import HylyButton from "storybookComponents/Button";
import EventList from "storybookComponents/EventList";
import EventFilters from "storybookComponents/EventFilters";
import Header from "components/Header";
import Modal from "components/Modal";
import SearchBox from "components/SearchBox";
import Loader from "storybookComponents/Loader";
import ToastMessage from "storybookComponents/Toast";
import * as EventApis from "relay/event";
import cancelEvent from "relay/event/mutations/cancelEvent";
import archiveEvent from "relay/event/mutations/archiveEvent";
import unarchiveEvent from "relay/event/mutations/unarchiveEvent";
import duplicateEvent from "relay/event/mutations/duplicateEvent";
import environment from "environments/environment";
import { getEditEventPath, getCreateEventPath, getPreviewUrl, getEventEditPath, getPublishPath, getScheduleInvitePath } from "constants/path"
import { MONTHS, MINUTES } from "constants/index";
import { getPropertyId, getEventFilters } from "common";
import { eventsGroupSorting, groupByMonth, setEventsProp, refreshInterval } from "./util";
import styles from "./style";
import NoEventIcon from './assets/no-event.svg';
import publishEvent from "relay/event/mutations/publishEvent.js"
import rescheduleHyevent from "relay/event/mutations/rescheduleEvent.js"
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import ConfirmPoup from "./confirm";
import { parseDateToString } from "../Event/util";
import UserContext from 'context/UserContext';
import DropDown from "components/DropDown";
import { getUpcomingEventCode, getUpcomingEventUrl } from "constants/path"
import { parseBody } from "content/Event/util";
import AttendessDetails from "./AttendeesDetails"
import moment from "moment";
import CalendarHeader from "./CalendarComponents/CalendarHeader";
import CalendarBox from "./CalendarComponents/CalendarBox"
import { getPreviousMonday, addDays } from "./CalendarUtils";
import ReschedulePopup from "./Reschedule";
import EventTitleSelect from "./eventTypeSelect";
import "moment-timezone"
import { getDisplayTime } from "content/Event/util/date.js";
import { checkIfEmailExist } from "content/utils/commonParsing";
const Events = withStyles(styles)(React.memo(({
  classes,
  history,
  setTitle,
  isApprover,
  approverSettings,
  setOriginNavItems,
  orgLevel,
  isNotificationsBarVisible,
  ...rest
}) => {
  const [events, setEvents] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [chosenStatus, setChoseStatus] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [noEventText, setNoEventText] = React.useState('');
  // toast states
  const [openToast, setOpenToast] = React.useState(false);
  const [variant, setVariant] = React.useState("success");
  const [autoHideDuration, setAutoHideDuration] = React.useState(2000)
  const [unDoAvailable, setUnDoAvailable] = React.useState(false)
  const [eventItemTemp, setEventItemTemp] = React.useState(undefined)
  const [plainEvents, setPlainEvents] = React.useState([]);
  const [message, setMessage] = React.useState("");
  const [modalOpen, setModalOpen] = React.useState(false);
  const [eventToCancel, setEventToCancel] = React.useState(null);
  const [cancelReason, setCancelReason] = React.useState("");
  const [openAttendeesList, setOpenAttendeesList] = React.useState(false);
  const [attendees, setAttendees] = React.useState([]);
  const [attendeesListEventTitle, setAttendeesListEventTitle] = React.useState('');
  const [attendeesListTotalGuests, setAttendeesListTotalGuests] = React.useState(0);
  const [rsvpNumber, setRsvpNumber] = React.useState(0);
  const [disabled, setDisabled] = React.useState();
  const [publishConfirm, setPublishConfirm] = React.useState(false);
  const [publishConfirmMsg, setPublishConfirmMsg] = React.useState(false);
  const [draftEvent, setDraftEvent] = React.useState()
  const [eventId, setEventId] = React.useState();
  const userName = localStorage.getItem("usename");
  const [upcoming, setUpcoming] = React.useState(false);
  const [eventRSVP, setSelectedEvent] = React.useState(false);
  const [moreLoading, setMoreLoading] = React.useState(false);
  const [pageInfo, setPageInfo] = React.useState();
  const [rawEvents, setRawEvents] = React.useState([])
  const [listView, setListView] = React.useState(true);
  const [date, setDate] = React.useState(moment(new Date()));
  const [openReschedule, setReschedule] = React.useState();
  const [eventType, setEventType] = React.useState('all')
  const { subOrgDetails } = React.useContext(UserContext);

  // Calendar functions
  const goToday = () => {
    setDate(moment(new Date()));
  };

  const goNext = () => {
    setDate(moment(addDays(new Date(date), 28)));
  };

  const goPrev = () => {
    setDate(moment(addDays(new Date(date), -28)));
  };

  const propertyIdTemp = getPropertyId();
  const eventFilters = getEventFilters();

  const dropDownDummyData = [
    {
      title: "Preview",
      url: getUpcomingEventUrl(),
    },
    {
      title: "Embed URL",
      url: getUpcomingEventUrl(),
    },
    {
      title: "Embed Code",
      url: getUpcomingEventCode(),
    }
  ]

  // set the header bar title
  React.useEffect(() => {
    setTitle('Events');
  }, []);

  const loadMoreClick = () => {

    loadMoreEvents({
      propertyId: propertyIdTemp,
      search: search,
      status: chosenStatus.toString(),
      before: pageInfo.startCursor,
      type: eventType
    });
  }

  const onClickNewEvent = () => {
    history.push(getCreateEventPath());
    window.scrollTo(0, 0);
  };

  const getEvents = (propertyId, startAt, endAt, status = null, search = null, last = 30, before, type) => {
    return new Promise(function (resolve, reject) {
      EventApis.getEvents(propertyId, startAt, endAt, status, search, last, before, type).then((res, err) => {
        if (err || res.errors || res.error) {
          resolve(false);
        }
        resolve(res);
      });
    });
  };


  const getAttendees = async (eventId) => {
    try {
      const response = await EventApis.getAttendees(eventId);
      if (response.attendees) {
        const attendees = response.attendees.edges;
        if (attendees) {
          setAttendees(attendees);
          return attendees
        } else {
          return null
        }
      }
    }
    catch (error) {
      console.error(error);
      return null
    }
  };

  const loadMoreEvents = async ({ propertyId, startAt, endAt, status, search, last, before, type }) => {
    try {
      setMoreLoading(true)
      let results = await getEvents(propertyId, startAt, endAt, status, search, last, before, type);
      if (results.hyevents.pageInfo) {
        setPageInfo(results.hyevents.pageInfo)
      }
      if (results.hyevents) {
        let _events = [...rawEvents, ...results.hyevents.edges]
        setRawEvents(_events)
        let _plainEvents = _events.map(e => e.node)
        setPlainEvents(_plainEvents);
        await setEvents(_(_events.map((event) => groupByMonth(event, subOrgDetails.timezoneString))).orderBy('monthYear', 'desc').groupBy('key').map((items, key) => {
          return {
            key,
            events: _.map(items, 'event')
          }
        }).value());
      }

      setMoreLoading(false)
    } catch (Err) {
      setMoreLoading(false)
      console.log("Err", Err)
    }
  }

  const loadEvents = React.useCallback(async ({ propertyId, startAt, endAt, status, search, last, before, type }) => {
    await setLoading(true);
    const _events = await getEvents(propertyId, startAt, endAt, status, search, last, before, type);
    if (_events.hyevents) {
      setRawEvents(_events.hyevents.edges)
      let _plainEvents = _events.hyevents.edges.map(e => e.node)
      setPlainEvents(_plainEvents)
      await setEvents(_(_events.hyevents.edges.map((event) => groupByMonth(event, subOrgDetails.timezoneString))).orderBy('monthYear', 'desc').groupBy('key').map((items, key) => {
        return {
          key,
          events: _.map(items, 'event')
        }
      }).value());
      setLoading(false);
    }
    if (_events.hyevents?.pageInfo) {
      setPageInfo(_events.hyevents.pageInfo)
    }
  }, []);

  const cancelEventHandler = async (event, cancelReason) => {
    let message = parseBody(cancelReason);
    cancelEvent(environment, {
      id: event.id,
      cancelReason: message
    }).then(() => {
      if (!listView) {
        loadEvents({
          propertyId: getPropertyId(),
          startAt: getPreviousMonday(new Date(date)).toISOString(),
          endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
          status: chosenStatus.toString(),
          last: null,
          search: search,
          type: eventType
        })
      } else {
        loadEvents({
          propertyId: propertyIdTemp,
          search: search,
          status: chosenStatus.toString(),
          type: eventType
        });
      }
      setVariant("success");
      setMessage(`Event '${event.title}' is canceled successfully.A Cancelation email has been sent to all the RSVPs.`);
      setOpenToast(true);
    }).catch(err => console.log("err:", err));
  }

  const handleLabelClickedCallback = (filters) => {
    setChoseStatus(filters);
    if (!listView) {
      loadEvents({
        propertyId: getPropertyId(),
        startAt: getPreviousMonday(new Date(date)).toISOString(),
        endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
        status: filters.toString(),
        last: null,
        search: search,
        type: eventType
      })
    } else {
      loadEvents({
        propertyId: propertyIdTemp,
        search: search,
        status: filters.toString(),
        type: eventType
      });
    }
  };

  const handleViewChangedClickedCallback = (value) => {
    if (!value) {
      // Get events for this month
      loadEvents({
        propertyId: getPropertyId(),
        startAt: getPreviousMonday(new Date(date)).toISOString(),
        endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
        status: chosenStatus.toString(),
        last: null,
        search: search,
        type: eventType
      })
    } else {
      // Get events for the list view
      loadEvents({
        propertyId: getPropertyId(),
        search: search,
        status: chosenStatus.toString(),
        type: eventType
      })
    }
    setListView(value)
  };

  const handleSearch = (search) => {
    setSearch(search)
    if (!listView) {
      loadEvents({
        propertyId: getPropertyId(),
        startAt: getPreviousMonday(new Date(date)).toISOString(),
        endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
        status: chosenStatus.toString(),
        last: null,
        search: search,
        type: eventType
      })
    } else {
      loadEvents({
        propertyId: propertyIdTemp,
        search: search,
        status: chosenStatus.toString(),
        type: eventType
      });
    }
  };

  const handleDuplicateClickedCallback = (event) => {
    duplicateEvent(environment, {
      id: event.id
    }).then(() => {
      if (!listView) {
        loadEvents({
          propertyId: getPropertyId(),
          startAt: getPreviousMonday(new Date(date)).toISOString(),
          endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
          status: chosenStatus.toString(),
          last: null,
          search: search,
          type: eventType
        })
      } else {
        loadEvents({
          propertyId: propertyIdTemp,
          search: search,
          status: chosenStatus.toString(),
          type: eventType
        });
      }
      setVariant("success");
      setMessage(`A copy of ${event.eventTitle} has been created successfully.You can find it under current date / month.`);
      setOpenToast(true);
    }).catch(err => console.log("err:", err));
  };

  const handleArchiveClickedCallback = async (event) => {
    archiveEvent(environment, {
      id: event.id
    }).then(() => {
      if (!listView) {
        loadEvents({
          propertyId: getPropertyId(),
          startAt: getPreviousMonday(new Date(date)).toISOString(),
          endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
          status: chosenStatus.toString(),
          last: null,
          search: search,
          type: eventType
        })
      } else {
        loadEvents({
          propertyId: propertyIdTemp,
          search: search,
          status: chosenStatus.toString(),
          type: eventType
        });
      }
      setVariant("success");
      setAutoHideDuration(3000); // should be returned to the initial value after closing toast
      setUnDoAvailable(true); // should be returned to the initial value after closing toast
      setMessage(`You have archived ‘${event.eventTitle} ’ event successfully.`);
      setOpenToast(true);
      setEventItemTemp(event)
      setTimeout(() => {
        setAutoHideDuration(2000)
        setUnDoAvailable(false)
        setEventItemTemp(undefined)
      }, 4000);
    }).catch(err => console.log("err:", err));
  };

  const handleUnarchiveCallback = async (event) => {
    unarchiveEvent(environment, {
      id: event.id
    }).then(() => {
      if (!listView) {
        loadEvents({
          propertyId: getPropertyId(),
          startAt: getPreviousMonday(new Date(date)).toISOString(),
          endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
          status: chosenStatus.toString(),
          last: null,
          search: search,
          type: eventType
        })
      } else {
        loadEvents({
          propertyId: propertyIdTemp,
          search: search,
          status: chosenStatus.toString(),
          type: eventType
        });
      }
      setAutoHideDuration(2000)
      setUnDoAvailable(false)
      setEventItemTemp(undefined)
      setVariant("success");
      setMessage(`You have unarchived ‘${event.eventTitle} ’ event successfully.`);
      setOpenToast(true);
    }).catch(err => console.log("err:", err));
  }

  const handleEditClickedCallback = (event) => {
    history.push(getEventEditPath(event));
    window.scrollTo(0, 0);
  };

  const handleCancelClickedCallback = (event) => {
    setEventToCancel(event);
    setCancelReason(`We are sorry to say the ${event.title} has been canceled due to unforeseen circumstances. We apologize for any inconveniences this may cause.\n\nWe will inform you of our next event and hope to see you there!`);
    setModalOpen(true);
  };

  const handlePublishClickedCallback = (event) => {
    history.push(getPublishPath(event));
    window.scrollTo(0, 0);
  };

  const handleScheduleInviteClickedCallback = (event) => {
    history.push(getScheduleInvitePath(event));
    window.scrollTo(0, 0);
  };

  const closeToast = () => {
    setOpenToast(false);
  };


  const onPublish = async () => {
    try {
      let event = draftEvent;
      togglePublishConfirm();
      setDisabled(event.id);
      let result = await publishEvent(environment, {
        id: event.id,
        publishDate: new moment().tz(subOrgDetails.timezoneString).toISOString(),
        publish: "now"
      });
      if (result.publishHyevent) {
        setVariant("success");
        setMessage(`Event ${event.eventTitle} have been published successfully.You contacts can RSVP for the event now`);
        setOpenToast(true);
        await loadEvents({
          propertyId: propertyIdTemp,
          search: search,
          status: chosenStatus.toString(),
          type: eventType
        });
      } else {
        const uncatchableError = getErrorMessage(checkUncatchableError("publishEventMutation"));
        if (uncatchableError) {
          setVariant("error");
          setMessage(uncatchableError);
          setOpenToast(true);
        }
      }
      setDisabled("");
    }
    catch (error) {
      setVariant("error");
      setMessage("Something went wrong");
      setOpenToast(true);
      setDisabled("");
      console.log("error: ", error)
    }
  }

  const showNotification = (message, type) => {
    setVariant(type);
    setMessage(message);
    setOpenToast(true);
  }


  const onPrimaryActionClickedCallback = (event, btnText) => {
    if (btnText == "publish now") {
      setPublishConfirmMsg(`${event.eventTitle} has been scheduled to publish at ${parseDateToString(event.publishAt, subOrgDetails.timezoneString)}.Would look like to publish it now ? `)
      togglePublishConfirm();
      setDraftEvent(event);
    } else if (btnText == "schedule invite") {
      history.push(getScheduleInvitePath(event));
    } else {
      history.push(getEditEventPath(event));
      window.scrollTo(0, 0);
    }
  }

  const onPreviewClickedCallback = (event) => {
    window.open(getPreviewUrl(event.id))
  }

  const handleRSVPClickedCallback = async (event) => {
    // if (!isApprover) {
    setOpenAttendeesList(true);
    // }
    setSelectedEvent(event)
  };

  const handleCloseReschedule = () => {
    setReschedule(false)
  }
  const handleRescheduleClickedCallback = (event) => {
    setReschedule(event)
  }

  const handleTypeChange = async (type) => {
    setEventType(type);
    if (!listView) {
      await loadEvents({
        propertyId: getPropertyId(),
        startAt: getPreviousMonday(new Date(date)).toISOString(),
        endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
        status: chosenStatus.toString(),
        last: null,
        search: search,
        type: type
      })
    } else {
      await loadEvents({
        propertyId: propertyIdTemp,
        search: search,
        status: chosenStatus.toString(),
        type: type
      });
    }
  }

  const renderEvents = () => {
    return events.sort(eventsGroupSorting).map((item, index) => (
      <Box my={2} className={classes.eventsListWrapper}>
        <EventList
          key={index}
          monthYear={`${MONTHS[item.key.split("-")[1]]} ${item.key.split("-")[0]} `}
          events={setEventsProp(item.events, item.key, checkIfEmailExist(approverSettings?.approverEmails, userName), subOrgDetails.timezoneString)}
          onDuplicateClickedCallback={handleDuplicateClickedCallback}
          onEditClickedCallback={handleEditClickedCallback}
          onArchiveClickedCallback={handleArchiveClickedCallback}
          onCancelClickedCallback={handleCancelClickedCallback}
          onPrimaryActionClickedCallback={onPrimaryActionClickedCallback}
          onPreviewClickedCallback={onPreviewClickedCallback}
          onRSVPClickedCallback={handleRSVPClickedCallback}
          onPublishClickedCallback={handlePublishClickedCallback}
          onScheduleInviteClickedCallback={handleScheduleInviteClickedCallback}
          onUnarchiveCallback={handleUnarchiveCallback}
          onRescheduleClickedCallback={handleRescheduleClickedCallback}
          disabled={disabled}
        />
      </Box>
    ))
  }

  const renderEventsList = () => {
    if (events.length === 0) {
      return <Box display="flex" alignItems="center" justifyContent="center" className={classes.noEventsWrapper}>
        <img src={NoEventIcon} alt="No events" />
        <Typography variant="h6" className={classes.noEventsText}>{noEventText} Click <strong>‘+Event’</strong> button to create new</Typography>
      </Box>
    } else {
      return (
        <div>
          {renderEvents()}
          {
            (pageInfo && pageInfo.hasPreviousPage) ? <div className={classes.loadMore} onClick={moreLoading ? () => { } : loadMoreClick}>{moreLoading ? "Loading..." : "Load More"}</div> : null
          }
        </div>)
    }
  }

  const togglePublishConfirm = () => {
    setPublishConfirm(!publishConfirm)
  }

  React.useEffect(() => {
    setTitle('Events');
    loadEvents({
      propertyId: propertyIdTemp,
      search: search,
      status: chosenStatus.toString(),
      type: eventType
    });
    setOriginNavItems(orgLevel);

  }, []);


  React.useEffect(() => {
    if (search === '' && chosenStatus.toString() === '') {
      setNoEventText('No events available.')
    } else {
      setNoEventText('Oops! No event found.')
    }
  }, [search, chosenStatus])

  // Get events when month changes
  React.useEffect(() => {
    if (!listView) {
      loadEvents({
        propertyId: getPropertyId(),
        startAt: getPreviousMonday(new Date(date)).toISOString(),
        endAt: addDays(getPreviousMonday(new Date(date)), 27).toISOString(),
        status: chosenStatus.toString(),
        last: null,
        search: search,
        type: eventType
      })
    }
  }, [date])

  const handleRescheduleCallback = async (event, startAt, endAt, publishAt) => {
    try {
      let resultReschedule = await rescheduleHyevent(environment, {
        id: event.id,
        endAt: endAt,
        startAt: startAt,
        publishDate: publishAt,
        displayTime: getDisplayTime(startAt, endAt),
      })
      if (resultReschedule.rescheduleHyevent && resultReschedule.rescheduleHyevent.hyevent) {
        if (approverSettings.approvalRequired && !isApprover) {
          showNotification(
            `${event.eventTitle} is successfully resend for approval.`,
            "success"
          );
        } else {
          showNotification(`${event.eventTitle} is successfully rescheduled.`, "success");
        }
      } else {
        const uncatchableError = getErrorMessage(checkUncatchableError("rescheduleEventMutation"));
        if (uncatchableError) {
          showNotification(uncatchableError, "error");
        }
      }
      loadEvents({
        propertyId: propertyIdTemp,
        search: search,
        status: chosenStatus.toString(),
        type: eventType
      });
    } catch (err) {
      showNotification('Something went wrong', "error");
      console.log("Err", err)
    }
  }

  return (
    <>
      {
        openAttendeesList ? <AttendessDetails
          getAttendees={getAttendees}
          setOpenAttendeesList={setOpenAttendeesList}
          events={plainEvents}
          eventRSVP={eventRSVP}
          isNotificationsBarVisible={isNotificationsBarVisible}
          showNotification={showNotification}
        /> :
          <>
            <Header
              title={<EventTitleSelect eventType={eventType} classes={classes} handleTypeChange={handleTypeChange} />}
              calendar={listView ? null : <CalendarHeader
                classes={classes}
                date={date}
                goToday={goToday}
                goPrev={goPrev}
                goNext={goNext}
                newEvent={onClickNewEvent}
              />}
            >
              <Box display="flex" alignItems="center">
                <SearchBox
                  onSearch={handleSearch}
                  className={classes.searchBox}
                />
                <Divider orientation="vertical" flexItem className={classes.verticalDivider} />
                {
                  listView ? <DropDown placeHolder="Upcoming Events" data={dropDownDummyData} /> : null
                }
                <HylyButton className={classes.hylyEvent} color="hylyBlue" type="submit" variant="primary" size="sm" onClick={onClickNewEvent}>
                  + Event
                </HylyButton>
              </Box>
            </Header>
            <div id="table-container-hyEvents" className={`${classes.root} ${isNotificationsBarVisible && classes.customRoot}`}>
              <ToastMessage
                variant={variant}
                message={message}
                open={openToast}
                onCloseCallback={closeToast}
                autoHideDuration={autoHideDuration}
                unDoAvailable={unDoAvailable}
                unDoCallback={() => {
                  unDoAvailable && handleUnarchiveCallback(eventItemTemp)
                }}
              />
              <ReschedulePopup
                open={openReschedule}
                toggler={handleCloseReschedule}
                approverSettings={approverSettings}
                isApprover={isApprover}
                subOrgDetails={subOrgDetails}
                classes={classes}
                showNotification={showNotification}
                handleRescheduleCallback={handleRescheduleCallback}
              />
              <ConfirmPoup
                classes={classes}
                title="Publish Now"
                open={publishConfirm}
                toggler={togglePublishConfirm}
                action={onPublish}
              >
                <Typography>
                  {publishConfirmMsg}
                </Typography>
              </ConfirmPoup>
              <Modal
                open={modalOpen}
                handleClose={() => setModalOpen(false)}
                maxWidth="sm"
                title="Cancel Event"
                actionChildren={
                  <>
                    <Button disbaled={!cancelReason} onClick={() => setModalOpen(false)} className={classes.closeCancelModal}>
                      do not cancel
                    </Button>
                    <Button disabled={!cancelReason} variant="secondary" className={classes.cancelButton} onClick={() => {
                      setModalOpen(false);
                      cancelEventHandler(eventToCancel, cancelReason);
                    }}>
                      yes, cancel event
                    </Button>
                  </>
                }
              >
                <Typography className={classes.description}>Are you sure, you want to cancel the <strong>{eventToCancel && eventToCancel.eventTitle}</strong> on <strong>{eventToCancel && `${eventToCancel.weekday}, ${eventToCancel.monthYear.split('-')[0]} - ${eventToCancel.startTime} `}</strong> ?</Typography>

                <Box className={classes.cancelFieldLabel} color="#999" fontSize={12}>Message for Attendees</Box>
                <InputBase
                  multiline
                  rows={6}
                  value={cancelReason}
                  onChange={(event) => setCancelReason(event.target.value)}
                  variant="outlined"
                  fullWidth
                  className={classes.cancelField}
                />
              </Modal>
              <div className={classes.eventListWrapper}>
                <div className={classes.eventFiltersWrapper}>
                  <EventFilters
                    chosenStatus={chosenStatus}
                    filters={eventFilters}
                    onLabelClickedCallback={handleLabelClickedCallback}
                    onViewChangedClickedCallback={handleViewChangedClickedCallback}
                  />
                </div>
                {loading ? <Loader /> : listView ? renderEventsList() : <CalendarBox
                  date={date}
                  events={rawEvents}
                  onDuplicateClickedCallback={handleDuplicateClickedCallback}
                  onEditClickedCallback={handleEditClickedCallback}
                  onArchiveClickedCallback={handleArchiveClickedCallback}
                  onCancelClickedCallback={handleCancelClickedCallback}
                  onPreviewClickedCallback={onPreviewClickedCallback}
                  onUnarchiveClickedCallback={handleUnarchiveCallback}
                  onPublishClickedCallback={onPrimaryActionClickedCallback}
                />}
              </div>
            </div>
          </>
      }
    </>
  )
}));

export default Events;
